import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { PUBLIC_HOME_PATH } from "./public-home-path";
import SupportContactHint from "./legal/SupportContactHint";

/** Holodeck: distinct route for students whose enrollments are archived, so there is no redirect loop to /join. */
export default function NoActiveClassesPage() {
  const { identity, signOut, setEnrollmentSummary } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  return (
    <main className="page">
      <div className="card card-wide">
        <p className="eyebrow">Student</p>
        <h1>No active cohorts</h1>
        <p className="lede">
          Hi{identity?.email ? `, ${identity.email}` : ""}. You do not have any active cohort enrollments right now.
          Ask your teacher for a new join code when the next cohort opens.
        </p>
        <p className="muted">
          This screen replaces looping through join flows when every enrollment is archived (Holodeck
          identity-auth feature).
        </p>

        {error ? <p className="warn-banner">{error}</p> : null}

        <div className="actions">
          <Link to="/join" className="btn primary">
            Enter join code
          </Link>
          <button
            type="button"
            className="btn secondary"
            onClick={() => {
              void (async () => {
                try {
                  setError(null);
                  await setEnrollmentSummary("active");
                  navigate("/lessons", { replace: true });
                } catch (e) {
                  setError(e instanceof Error ? e.message : "Update failed");
                }
              })();
            }}
          >
            Dev: clear archived-only flag
          </button>
          <button type="button" className="btn secondary" onClick={() => signOut()}>
            Sign out
          </button>
        </div>

        <p className="fineprint">
          <Link to={PUBLIC_HOME_PATH}>Home</Link>
        </p>

        <SupportContactHint className="support-contact-hint fineprint" />
      </div>
    </main>
  );
}
